export default {
	data:
		function () {
			return {
			}
	},
	created: function () {
		this.eventHub.$emit('setDisplayPrevious', true);
    },
	methods: {
 	}
}
